/* eslint-disable import/prefer-default-export */

export const updateUser = payload => ({
  type: "UPDATE_USER",
  payload,
});
